import { Injectable } from '@angular/core';
import { CommonService } from 'src/app/shared/utils/common.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { empModulo } from '../../diccionarios/empModulo';

@Injectable({
  providedIn: 'root'
})
export class DesvinculacionService {

  diccionarioUrl: any;
  urlEmpTerceros: string;

  constructor(
    private commom: CommonService,
    private utilServices: UtilsService
    ) {
    this.urlEmpTerceros = this.utilServices.getNomina();
    this.diccionarioUrl = empModulo.url.epp.administrador;
  }

  getEmpresasNoCorporativos(){
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.empresaNoCorporativos);
  }

  getEmpleadosByEmpresas(codEmpresa: string){
    return this.commom.peticionGetConHeader(this.urlEmpTerceros + this.diccionarioUrl.empleadosByEmpresa + `/${codEmpresa}`);
  }

  desvicularContratista(innObj: any) {
    return this.commom.peticionPostConHeader(this.urlEmpTerceros + this.diccionarioUrl.desvicularContratista, innObj);
  }

}
